import { AbsolutesWhiteColors, TextColors } from '@picsart/design-system/foundation/colors';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { mediaQuery } from '@picsart/rc/helpers';
import {
  ignoreRTL,
  isLeftToRight,
  isRightToLeft,
} from '@picsart/design-system/foundation/styleHelpers';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  () => ({
    root: {
      position: 'relative',

      [mediaQuery(1023)]: {
        marginTop: Spacings.s40,
      },
    },
    title: {
      display: '-webkit-box',
      '-webkit-line-clamp': 2,
      '-webkit-box-orient': 'vertical',
      fontWeight: FontWeights.semibold,
      fontSize: FontSizes.s36,
      color: TextColors.tint1,
      lineHeight: LineHeights.l50,
      overflow: 'hidden',

      [mediaQuery(1365)]: {
        fontSize: FontSizes.s30,
        lineHeight: LineHeights.l36,
      },
      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        '-webkit-line-clamp': 3,
        fontSize: FontSizes.s24,
        lineHeight: LineHeights.l32,
      },
    },
    descriptionHolder: {
      transform: 'translate3d(0,0,0)',
      transition: 'max-height 0.46s linear',
      position: 'relative',
      maxHeight: 1000,
      '-webkit-box-orient': 'vertical',
      color: TextColors.tint1,
      textAlign: 'justify',
      overflow: 'hidden',

      '-webkit-line-clamp': 14,
      marginTop: Spacings.s12,
      fontWeight: FontWeights.normal,
      fontSize: FontSizes.s16,
      lineHeight: LineHeights.l24,

      [mediaQuery(1365)]: {
        '-webkit-line-clamp': Spacings.s16,
        marginTop: Spacings.s16,
        fontSize: FontSizes.s14,
        lineHeight: LineHeights.l20,
      },
      [mediaQuery(1023)]: {
        '-webkit-line-clamp': 18,
      },
      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        marginTop: Spacings.s12,
      },
      '&.collapsed': {
        maxHeight: 364,

        '&.isBox': {
          display: '-webkit-box',
        },

        [mediaQuery(1365)]: {
          maxHeight: 320,
        },

        [mediaQuery(1023)]: {
          maxHeight: 360,
        },
        // [mediaQuery(766)]: {
        '@media screen and (max-width: 766px)': {
          maxHeight: 400,
        },
      },
    },
    descriptionContent: {
      display: 'inline-block',
      verticalAlign: 'top',
      width: '100%',
    },
    expanderHolder: {
      position: 'absolute',

      bottom: Spacings.s0,

      [isLeftToRight]: {
        right: Spacings.s0,
      },
      [isRightToLeft]: {
        left: Spacings.s0,
      },
      '&.expanded': {
        position: 'relative',
        float: 'right',
      },
      '&:before': {
        content: "''",
        display: 'inline-block',
        width: 48,
        height: '100%',
        position: 'absolute',
        top: Spacings.s0,

        [isLeftToRight]: {
          right: '100%',
          backgroundImage: `linear-gradient(-90deg, ${AbsolutesWhiteColors.base.default}, 34px, transparent)`,
        },
        [isRightToLeft]: {
          left: '100%',
          backgroundImage: `linear-gradient(90deg,  ${AbsolutesWhiteColors.base.default}, 34px, transparent)`,
        },
      },
    },
    actionOuterHolder: {
      display: 'flex',
      marginTop: Spacings.s24,

      [mediaQuery(1023)]: {
        justifyContent: 'center',
      },
      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        marginTop: Spacings.s16,
      },
    },
    actionInnerHolder: {
      display: 'flex',
      flexWrap: 'no-wrap',

      [mediaQuery(1023)]: {
        justifyContent: 'center',
        width: '100%',
      },

      // [mediaQuery(766)]: {
      '@media screen and (max-width: 766px)': {
        flexWrap: 'wrap',
      },
    },
    actionItemHolder: {
      [isLeftToRight]: {
        marginRight: Spacings.s16,
      },
      [isRightToLeft]: {
        marginLeft: Spacings.s16,
      },

      [mediaQuery(1023)]: {
        width: '100%',
      },

      // [mediaQuery(766)]: {
      '@media screen and (max-width: 766px)': {
        flexWrap: 'wrap',

        [ignoreRTL]: {
          margin: [Spacings.s0, Spacings.s0, Spacings.s16, Spacings.s0],

          '&:last-child': {
            margin: Spacings.s0,
          },
        },
      },

      '&:last-child': {
        margin: Spacings.s0,
      },
    },
    action: {
      width: '100%',
      minWidth: 148,
      padding: [Spacings.s12, Spacings.s24],
      fontWeight: FontWeights.medium,
      fontSize: FontSizes.s14,
      lineHeight: LineHeights.l20,
    },
  }),
  {
    name: 'body-text-with-double-cta-content',
  },
);

export default useStyles;
